import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  InputBase,
  Box,
  Button,
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import PhoneIcon from "@mui/icons-material/Phone";
import PersonIcon from "@mui/icons-material/Person";
import ColorData from "../CstmTheme/ColorData";
import ImgPath from "../../Constants/Imgs";
import { useNavigate } from "react-router-dom";
import { RouteUrls } from "../../Constants/RouteUrls";
import { useSelector } from "react-redux";
import { UserInitialStateType } from "DataTypes/Redux";
import LanguageSelector from "Components/commonComponents/LanguageSelector";
import React from "react";
import DesktopNav from "Components/commonComponents/DesktopNav ";
import MenuList from "Components/commonComponents/MenuList";
import { Admin_Number } from "Utils/Common";
import MobileDrawer from "Components/commonComponents/HederDrawer";
import dayjs from "dayjs";

// Navigation handler function
export const handleNavigation = (item: string) => {
  switch (item) {
    // Legal Services
    case "Legal Notice-Send/Reply":
      window.location.href = "/legal-notice.html";
      break;
    case "Legal Drafting-Agreement":
      window.location.href = "/legal-drafting.html";
      break;
    case "Legal Document Review":
      window.location.href = "/legal-review.html";
      break;
    case "File or Defend a Case":
      window.location.href = "/file-a-case.html";
      break;
    case "Talk to a Lawyer":
      window.location.href = "/online-legal-consultation.html";
      break;
    case "Consumer Complaint":
      window.location.href = "/consumer-complaint.html";
      break;
    case "Virtual Legal Counsel":
      window.location.href = "/legal-manager.html";
      break;

    // Legal Finance
    case "Third Party Litigation Funding":
      window.location.href = "/third-party-litigation-funding-support.html";
      break;
    case "New Feature-Coming Soon":
      window.location.href = "#";
      break;

    // ODR
    case "Online Dispute Resolution":
      window.location.href = "/online-dispute-resolution.html";
      break;
    case "Online Mediation":
      window.location.href = "/mediation-online-dispute-resolution.html";
      break;
    case "Online Arbitration":
      window.location.href = "/arbitration-online-dispute-resolution.html";
      break;
    case "Online Negotiation":
      window.location.href = "/negotiation-online-dispute-resolution.html";
      break;

    // Talk with Expert
    case "Talk to a CA":
      window.location.href = "/online-ca-consultation.html";
      break;
    case "Talk to a CS":
      window.location.href = "/chartered-secretary-cs.html";
      break;

    // Start-up Support
    case "Incorporate your Business":
      window.location.href = "/incorporate-your-business.html";
      break;
    case "Start-up Tool Kit":
      window.location.href = "/start-up-toolkit.html";
      break;
    case "Fund Raising":
      window.location.href = "/fund-raising.html";
      break;
    case "DPDP Compliance":
      window.location.href = "/dpdp-compliance.html";
      break;
    case "Due-Diligence":
      window.location.href = "/due-diligence-for-investment.html";
      break;
    case "Website Development":
      window.location.href = "/website-development-service.html";
      break;
    case "Posh Compliance":
      window.location.href = "/posh-compliance-support.html";
      break;
    case "Startup & Company Shutdown":
      window.location.href = "/startup-&-company-situation.html";
      break;
    case "Founder's Exit":
      window.location.href = "/founder's-exit.html";
      break;
    case "Digital Signature":
      window.location.href = "/digital-signature-certificate.html";
      break;
    case "Startup India Registration":
      window.location.href = "/startup-india-registration.html";
      break;

    // Business Registration
    case "Register Pvt Limited":
      window.location.href = "/register-private-limited-company.html";
      break;
    case "Register LLP":
      window.location.href = "/register-llp.html";
      break;
    case "Register Subsidiary":
      window.location.href = "/register-indian-subsidiary-company-online.html";
      break;
    case "Register Producer Company":
      window.location.href = "/producer-company.html";
      break;
    case "Register OPC":
      window.location.href = "/register-one-person-company-online.html";
      break;
    case "Sole Proprietorship":
      window.location.href = "/register-sole-proprietorship.html";
      break;
    case "Register Partnership":
      window.location.href = "/register-partnership-firm-online.html";
      break;

    // Tax & Compliance
    case "Income Tax Return Filing":
      window.location.href = "/income-tax-return-filing.html";
      break;
    case "TDS/TCS Return Filing":
      window.location.href = "/tds-return-filing.html";
      break;
    case "GST Registration Online":
      window.location.href = "/gst-registration-online.html";
      break;
    case "GST Filing Online":
      window.location.href = "/gst-filing-online.html";
      break;
    case "Annual Accounting services":
      window.location.href = "/annual-compliance-services.html";
      break;
    case "Changes in Pvt Ltd":
      window.location.href = "/changes-private-limited-company.html";
      break;
    case "Changes in LLP":
      window.location.href = "/changes-limited-liability-partnership.html";
      break;
    case "Business Entity Conversion":
      window.location.href = "/business-entity-conversion.html";
      break;
    case "Secretarial Audit":
      window.location.href = "/secretarial-audit.html";
      break;
    case "AOC-4 XBRL Filing":
      window.location.href = "/AOC-4-XBRL-Filing.html";
      break;

    // Licenses and Registration
    case "Import Export Code":
      window.location.href = "/import-export-code.html";
      break;
    case "Register MSME":
      window.location.href = "/udyam-msme-registration.html";
      break;
    case "Register Real Estate Agent":
      window.location.href = "/real-estate-agent-registration.html";
      break;
    case "Register Legal Metrology License":
      window.location.href = "/legal-metrology-license-&-registration.html";
      break;
    case "Register Retail Drug & Cosmetics License":
      window.location.href = "/retail-drug-&-cosmetics-license.html";
      break;
    case "Register Ayush Retail & Manufacturing License":
      window.location.href = "/ayush-retail-&-manufacturing-license.html";
      break;
    case "Register Gem Vendor":
      window.location.href = "/gem-vendor-registration.html";
      break;
    case "Register PSARA License":
      window.location.href = "/psara-license-registration.html";
      break;
    case "Register FSSAI License":
      window.location.href = "/fssai-license-registration.html";
      break;
    case "HUF Registration":
      window.location.href = "/huf-registration.html";
      break;
    case "NGO Registration":
      window.location.href = "/register-ngo.html";
      break;

    // IP Registration
    case "Register Copyright":
      window.location.href = "/register-copyright.html";
      break;
    case "Register Patent":
      window.location.href = "/register-patent-online.html";
      break;
    case "Register Trademark":
      window.location.href = "/register-trademark.html";
      break;
    case "Register your Design":
      window.location.href = "/register-your-design.html";
      break;

    // Other Services
    case "File RTI Application":
      window.location.href = "/RTI.html";
      break;
    case "Legal Protection Plan For Companies & LLPs":
      window.location.href = "/for-company's-and-LLP.html";
      break;
    case "Legal Protection Plan For Individuals & Families":
      window.location.href = "/Individual-and-family.html";
      break;
    case "NRI Help Desk":
      window.location.href = "/NRI-and-overseas-indians-help-desk.html";
      break;

    default:
    // console.log(`Navigation for ${item} not implemented yet`);
  }
};
const Header = () => {
  const token = localStorage.getItem("token");
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );

  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
  const [expandedItems, setExpandedItems] = React.useState<{
    [key: string]: boolean;
  }>({});

  const currentDateTime = dayjs().format("D MMM, YYYY / h:mmA");

  const handleDrawerClick = (event: any) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClick = (event: any) => {
    if (isMobile) {
      setDrawerOpen(true);
    }
    // Remove TypeScript type
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleExpandClick = (itemLabel: string) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemLabel]: !prev[itemLabel],
    }));
  };

  // Navigation items from DesktopNav
  const navItems = [
    {
      id: "legalServices",
      label: "Legal Services",
      hasDropdown: true,
      submenu: [
        "Legal Notice-Send/Reply",
        "Legal Drafting-Agreement",
        "Legal Document Review",
        "File or Defend a Case",
        "Talk to a Lawyer",
        "Consumer Complaint",
        "Virtual Legal Counsel"
      ],
    },
    {
      id: "legalFinance",
      label: "Legal Finance",
      hasDropdown: true,
      submenu: ["Third Party Litigation Funding", "New Feature-Coming Soon"],
    },
    {
      id: "odr",
      label: "Online Dispute Resolution",
      hasDropdown: true,
      submenu: ["Online Dispute Resolution", "Online Mediation", "Online Arbitration", "Online Negotiation"],
    },
    {
      id: "talkExpert",
      label: "Talk with an Expert",
      hasDropdown: true,
      submenu: [
        "Talk to a Lawyer",
        "Talk to a CA",
        "Talk to a CS"
      ],
    },
    {
      id: "startupSupport",
      label: "Start-up Support Service",
      hasDropdown: true,
      submenu: [
        "Incorporate your Business",
        "Start-up Tool Kit",
        "Fund Raising",
        "DPDP Compliance",
        "Due-Diligence",
        "Virtual Legal Counsel",
        "Website Development",
        "Posh Compliance",
        "Startup & Company Shutdown",
        "Founder's Exit",
        "Digital Signature",
        "Startup India Registration"
      ],
    },
    {
      id: "businessReg",
      label: "Business Registration",
      hasDropdown: true,
      submenu: [
        "Register Pvt Limited",
        "Register LLP",
        "Register Subsidiary",
        "Register Producer Company",
        "Register OPC",
        "Sole Proprietorship",
        "Register Partnership"
      ],
    },
    {
      id: "taxCompliance",
      label: "Tax & Compliance",
      hasDropdown: true,
      submenu: [
        "Income Tax Return Filing",
        "TDS/TCS Return Filing",
        "GST Registration Online",
        "GST Filing Online",
        "Annual Accounting services",
        "Posh Compliance",
        "Changes in Pvt Ltd",
        "Changes in LLP",
        "Business Entity Conversion",
        "Secretarial Audit",
        "AOC-4 XBRL Filing"
      ],
    },
    {
      id: "licensesRegistrations",
      label: "Licenses & Registrations",
      hasDropdown: true,
      submenu: [
        "Import Export Code",
        "Register MSME",
        "Register Real Estate Agent",
        "Register Legal Metrology License",
        "Register Retail Drug & Cosmetics License",
        "Register Ayush Retail & Manufacturing License",
        "Register Gem Vendor",
        "Register PSARA License",
        "Register FSSAI License",
        "HUF Registration",
        "NGO Registration"
      ],
    },
    {
      id: "ipRegistration",
      label: "IP-Registration",
      hasDropdown: true,
      submenu: [
        "Register Copyright",
        "Register Patent",
        "Register Trademark",
        "Register your Design"
      ],
    },
    {
      id: "otherServices",
      label: "Other Services",
      hasDropdown: true,
      submenu: [
        "File RTI Application",
        "Legal Protection Plan For Companies & LLPs",
        "Legal Protection Plan For Individuals & Families",
        "NRI Help Desk"
      ],
    },
  ];

  return (
    <Box
      sx={{
        position: "sticky",
        // position: "fixed",
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar,
      }}
    >
      {/* Top Bar */}
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          backgroundColor: ColorData.primary.main, // Your theme color
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            minHeight: "none !important",
          }}
        >
          <Grid
            className="test1"
            width={"100%"}
            container
            alignItems="center"
            justifyContent={"space-between"}
            spacing={2}
          >
            {/* Left Side: Call Info */}
            <Grid size={{ xs: 6, md: 4, lg: 4 }}>
              <Box display="flex" alignItems="center">
                <Box
                  sx={{
                    mr: 1,
                    borderRadius: "50%",
                    border: "1px solid white", // white border
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <PhoneIcon sx={{ fontSize: "14px" }} /> {/* icon 14px */}
                </Box>
                <Typography
                  color="background.default"
                  sx={{ fontSize: "14px" }}
                >
                  Call Us&nbsp;${Admin_Number}
                </Typography>
              </Box>
            </Grid>

            {/* Center: Search Box */}
            {!isMobile && (
              <Grid
                size={{ md: 4, lg: 4 }}
                display="flex"
                justifyContent="center"
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#fff",
                    borderRadius: 1,
                    px: 1,
                    width: "18.125rem",
                    maxWidth: 500,
                  }}
                >
                  <SearchIcon sx={{ color: ColorData.primary.main }} />
                  <InputBase placeholder="Search..." sx={{ ml: 1, flex: 1 }} />
                </Box>
              </Grid>
            )}

            {/* Right Side */}
            <Grid size={{ xs: 6, md: 4, lg: 4 }}>
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                gap={2}
                flexWrap="nowrap"
              >
                {!isMobile && (
                  <>
                    <Typography
                      color="white"
                      variant="body2"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      {currentDateTime}
                    </Typography>
                    <Typography
                      color="white"
                      variant="body2"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Download App
                    </Typography>

                    <LanguageSelector />
                  </>
                )}
                {token ? (
                  <Button
                    startIcon={<PersonIcon />}
                    sx={{ color: "#fff", textTransform: "none" }}
                    onClick={() => navigate("/dashboard")}
                  >
                    {myInfo.firstname}
                  </Button>
                ) : (
                  <Button
                    startIcon={<PersonIcon />}
                    sx={{ color: "#fff", textTransform: "none" }}
                    onClick={() => navigate(RouteUrls.login)}
                  >
                    Login
                  </Button>
                )}

                <IconButton onClick={handleDrawerClick} sx={{ color: "#fff" }}>
                  <MenuIcon />
                </IconButton>
                <MenuList
                  menuAnchorEl={menuAnchorEl}
                  handleMenuClose={handleMenuClose}
                />
              </Box>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      {/* Bottom Header / Logo + Menu */}
      <AppBar
        position="static"
        color="transparent"
        elevation={1}
        sx={{
          paddingTop: "0.5rem",
          paddingBottom: "0.5rem",
          backgroundColor: "#fff",
          color: "#000",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar className="TEst">
          <Box
            component="img"
            src={"https://nolegalpaisa.com/assets/images/new_logo.webp"}
            alt="Logo"
            sx={{
              width: { xs: "150px", sm: "200px", md: "100px" },
              height: { xs: "60px", sm: "80px", md: "83px" },
              objectFit: "contain",
              cursor: "pointer",
              filter: "drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.3))",
              transition: "transform 0.2s ease-in-out",
              "&:hover": {
                transform: "scale(1.05)",
              },
            }}
            onClick={() => navigate("/")}
          />
          <Box
            sx={{ flexGrow: 1, display: "flex", justifyContent: "flex-end" }}
          >
            {!isMobile && (
              <DesktopNav navItems={navItems} onNavigate={handleNavigation} />
            )}
            {isMobile && (
              <IconButton
                onClick={handleMenuClick}
                sx={{ color: ColorData.text.primary }}
              >
                <MenuIcon />
              </IconButton>
            )}
          </Box>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <MobileDrawer
        open={drawerOpen}
        onClose={toggleDrawer}
        navItems={navItems}
        expandedItems={expandedItems}
        onExpandClick={handleExpandClick}
        onNavigate={handleNavigation}
      />
    </Box>
  );
};

export default Header;
